'use strict';
mpangoApp.controller('MtodoController',MtodoController);
function MtodoController($rootScope, $scope, $state,Mtodo, Notification, $filter, SweetAlert) {
	$scope.$on('$viewContentLoaded', function () {
        Mtodo.getTasks().success(function(data,status) {
    		var todoData = data.mtodos
    		$scope.mtodos = $filter('filter')(todoData, { status: "not done" });
    		$scope.cTodos = $filter('filter')(todoData, { status: "!not done" });
    	}).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    });
	$scope.currentPage = 1;
    $scope.pageSize = 10;
    $scope.pageChangeHandler = function(num) {};
	$scope.addTodo = function(task) {
		if (!task) {
			return;
		}
		$scope.saving = true;
		Mtodo.postTask(task).success(function(data,status) {
			$scope.newTodo = '';
			$scope.saving = false;
			$scope.mtodos.push(data.insertedD);
			Notification.success({message: data.message});
		}).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
  	};
  	$scope.update = function(tododata,formname,index) {
  		Mtodo.updateTask(tododata,formname).success(function(data) {
            if (formname === 'completed' ) {
            	$scope.mtodos.splice(index, 1);
            	$scope.cTodos.push(data.insertedD)
            }
            if (formname === 'incompleted') {
            	$scope.cTodos.splice(index, 1);
            	$scope.mtodos.push(data.insertedD)
            };
            if (formname === 'delete') {
            	$scope.mtodos.splice(index, 1);
            };
            Notification.success({message: data.message});        
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
  	};
}
MtodoController.$inject = ['$rootScope', '$scope', '$state','Mtodo', 'Notification', '$filter', 'SweetAlert'];